import { render, staticRenderFns } from "./VerFacturacionPantalla.vue?vue&type=template&id=61bc5154&"
import script from "./VerFacturacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./VerFacturacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports